import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import { GridStack } from 'gridstack';
import 'gridstack/dist/h5/gridstack-dd-native';
import LoginService from "../../services/login.service";

ko.bindingHandlers.gridstack = {
    init: function (element, valueAccessor, allBindingsAccessor, data, context) {
      ko.bindingHandlers.foreach.init(element, valueAccessor, allBindingsAccessor, data, context);
      return { controlsDescendantBindings: true };
    },

    update: function (element, valueAccessor, allBindingsAccessor, data, context) {
        var widgets = valueAccessor().panelsOA();

        var grid = GridStack.init({
                auto: false,
                cellHeight: 70,
                column: 4,
                margin: 0,
                handle: '.box-header',
                disableDrag: data.disableDrag()
            });
        grid.enableMove(!data.disableDrag(), true);

        function afterAddWidget(items) {
            var item = _.find(items, ['nodeType', 1]);
            grid.addWidget(item);

            let itemData = ko.dataFor(item);
            let elementsObs = valueAccessor().elementsObs;
            let elements = elementsObs();
            elements[itemData.id] = item;
            elementsObs(elements);

            ko.utils.domNodeDisposal.addDisposeCallback(item, function () {
                grid.removeWidget(item);

                let elements2 = elementsObs();
                if (elements2[itemData.id]) {
                  delete elements2[itemData.id]
                  elementsObs(elements2);
                }
            });
        }

        function getUpdatedValueAccessor() {
            return {
                data: widgets,
                afterRender: afterAddWidget
            };
        }

        ko.bindingHandlers.foreach.update(element, getUpdatedValueAccessor, allBindingsAccessor, data, context);
    }
};
